import React, { useState } from "react";
import {
    Table, Thead, Tbody, Tr, Th, Td, TableContainer, IconButton, Box, HStack, useToast, Heading, Flex, Button,
    Icon, Link
} from "@chakra-ui/react";
import { FaUserTimes, FaInfoCircle, FaUserPlus, FaEdit } from "react-icons/fa";
import ConfirmModal from "../users/ConfirmModal";
import CreateUserModal from "../users/CreateUserModal";
import UpdateUserModal from "../users/UpdateUserModal";
import useUsers from "../../hooks/useUsers";
import { PhoneIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import { stickyColHeaderProps, stickyColCellProps } from "../../constants/tableStyles";

const JobOpenings = ({ locationId }) => {
    const { users, loading, handleDeactivate, handleCreateUser, handleUpdateUser } = useUsers(locationId);
    const [selectedUser, setSelectedUser] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
    const toast = useToast();
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/careers/add-job-opening');
    };

    const openModal = (user) => {
        setSelectedUser(user);
        setIsModalOpen(true);
    };

    const openUpdateModal = (user) => {
        setSelectedUser(user);
        setIsUpdateModalOpen(true);
    };

    const confirmDeactivation = async () => {
        if (selectedUser) {
            await handleDeactivate(selectedUser.id);
            setIsModalOpen(false);
            toast({
                title: "User Deactivated",
                description: `${selectedUser.fullName} je deaktiviran.`,
                status: "success",
                duration: 3000,
                isClosable: true,
            });
        }
    };

    return (
        <>
            <Flex
                justify="space-between"
                align="center"
                mb={5}
                pl={4}
                pr={4}
            >
                <Heading size="lg" color="brand.700">Oglasi za posao</Heading>
                <Button bg="brand.600" color="white" boxShadow="soft" _hover={{ bg: "brand.700" }} onClick={() => handleClick}>
                    <FaUserPlus />
                </Button>
            </Flex>

            {loading ? <p>Učitavanje oglasa za posao...</p> : (
                <Box
                    bg="white"
                    borderRadius="xl"
                    border="1px solid"
                    borderColor="gray.100"
                    boxShadow="card"
                    p={3}
                    mx={4}
                >
                <TableContainer overflowX="auto">
                    <Table variant="striped" colorScheme="gray" size="sm">
                        <Thead>
                            <Tr>
                                <Th {...stickyColHeaderProps}>#</Th>
                                <Th>Naziv</Th>
                                <Th>Akcije</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {users.map((user, index) => (
                                <Tr key={user.id} _hover={{ bg: "gray.50" }}>
                                    <Td {...stickyColCellProps(index % 2 === 0)}>{index + 1}</Td>
                                    <Td fontWeight="bold">{user.fullName}</Td>
                                    <Td fontWeight="bold">
                                        <HStack spacing={2}>
                                            <Box as="span" border="1px solid" borderColor="red.200" bg="red.50" borderRadius="lg" p={1}>
                                                <IconButton
                                                    aria-label="Deactivate User"
                                                    icon={<FaUserTimes />}
                                                    color="red.500"
                                                    variant="ghost"
                                                    size="sm"
                                                    _hover={{ bg: "red.100" }}
                                                    onClick={() => openModal(user)}
                                                />
                                            </Box>
                                            <Box as="span" border="1px solid" borderColor="brand.200" bg="brand.50" borderRadius="lg" p={1}>
                                                <IconButton
                                                    aria-label="Edit User"
                                                    icon={<FaEdit />}
                                                    color="brand.600"
                                                    variant="ghost"
                                                    size="sm"
                                                    _hover={{ bg: "brand.100" }}
                                                    onClick={() => openUpdateModal(user)}
                                                />
                                            </Box>
                                        </HStack>
                                    </Td>
                                </Tr>
                            ))}
                        </Tbody>
                    </Table>
                </TableContainer>
                </Box>
            )}

            <ConfirmModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onConfirm={confirmDeactivation}
                message={`Želite li deaktivirati korisnika ${selectedUser?.fullName}?`}
            />
        </>
    );
};

export default JobOpenings;
